// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--6O8Zw";
export var spacer = "Breadcrumbs-module--spacer--dB6U2";
export var crumb = "Breadcrumbs-module--crumb--oXF1C";